/**
 * Well & Proof — Interactive features
 * Capsule explorer, feel-the-difference tabs, product capsule flip
 */
(function () {
  'use strict';

  var CAPSULE_DATA = {
    laxiva: {
      name: 'Laxiva',
      tagline: 'Overnight digestive comfort · 12 ingredients',
      color: '#009882',
      colorDark: '#007a68',
      ingredients: [
        { name: 'Haritaki', short: 'Gut motility', detail: 'Traditionally valued in Ayurveda, Haritaki helps support healthy digestion and natural bowel regularity by supporting the intestine’s natural muscle contractions and fluid movement.' },
        { name: 'Senna', short: 'Gentle nudge', detail: 'Stimulates natural colon peristalsis for regular bowel movements.' },
        { name: 'Ajwain', short: 'Digestive fire', detail: 'Naturally rich in thymol, Ajwain helps stimulate digestive secretions, supporting smooth food movement while easing occasional gas and discomfort.' },
        { name: 'Vidanga', short: 'Digestive flow', detail: 'Traditional support for gut motility and bowel regularity.' },
        { name: 'Pudina', short: 'Calm gut', detail: 'Rich in menthol, which helps relax smooth muscles of the digestive tract, promoting comfortable digestion and easing occasional bloating and gas.' },
        { name: 'Fennel', short: 'Gas relief', detail: 'Helps support the natural rhythm of digestive muscles, allowing trapped gas to pass more comfortably while reducing bloating.' },
        { name: 'Pomegranate', short: 'Gut tone', detail: 'Anardana seeds are rich in polyphenols that help support a healthy gut microbiome and comfortable digestion.' },
        { name: 'Hing', short: 'Gas ease', detail: 'Asafoetida is rich in sulfur compounds and ferulic acid that help support intestinal muscle relaxation and natural gas release.' },
        { name: 'Black Pepper', short: 'Absorption', detail: 'Rich in piperine, which helps stimulate digestive enzyme activity and supports nutrient absorption for efficient digestion.' },
        { name: 'Cardamom', short: 'Fresh finish', detail: 'Contains aromatic essential oils that help support digestive secretions and smooth movement of food through the digestive tract.' },
        { name: 'Black Salt', short: 'Mineral aid', detail: 'Traditionally used to support the body’s natural digestive process and promote comfortable digestion.' },
        { name: 'Rock Salt', short: 'Balance', detail: 'Essential minerals that help support digestive secretions and maintain fluid balance.' }
      ]
    },
    detoxa: {
      name: 'Detoxa',
      tagline: 'Reset. Cleanse. Refresh. · 7 ingredients',
      color: '#1a7a6d',
      colorDark: '#0f5c52',
      ingredients: [
        { name: 'Senna', short: 'The evacuate', detail: 'Stimulates natural colon peristalsis for gut clearance.' },
        { name: 'Psyllium husk', short: 'The scrub', detail: 'Helping stool move more smoothly through the colon and supporting regular, comfortable bowel movements.' },
        { name: 'Haritaki', short: 'The bind', detail: 'Supports healthy digestion and natural gut motility, helping promote smooth stool passage through the intestine’s natural contractions and fluid balance.' },
        { name: 'Fenugreek', short: 'Soft bulk', detail: 'Rich in soluble fiber and mucilage to increase stool bulk and softness, while helping nourish beneficial gut bacteria.' },
        { name: 'Probiotic', short: 'Balance', detail: 'Lactobacillus acidophilus helps maintain a healthy gut microbiome, supporting motility, regularity, and overall digestive wellness.' },
        { name: 'Mint Oil', short: 'Soothe', detail: 'Menthol helps ease the digestive spasm and supports comfortable digestion.' },
        { name: 'Aloe Vera', short: 'Gut lining', detail: 'Rich in polysaccharides including acemannan that help support the gut lining and maintain a healthy digestive environment.' }
      ]
    }
  };

  function initFeelOrbits() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.feel-tap__ring').forEach(function (ring) {
      var outer = ring.classList.contains('feel-tap__ring--outer');
      var duration = (outer ? 10 : 7) + Math.random() * 18;
      var delay = -(Math.random() * duration);
      ring.style.setProperty('--orbit-duration', duration.toFixed(2) + 's');
      ring.style.setProperty('--orbit-delay', delay.toFixed(2) + 's');
      ring.style.animationDirection = Math.random() > 0.5 ? 'reverse' : 'normal';
    });
  }

  function initFeelTabs() {
    var root = document.getElementById('feel-difference');
    if (!root) return;

    var tabs = root.querySelectorAll('[data-feel-tab]');
    var panels = root.querySelectorAll('[data-feel-panel]');
    var glider = root.querySelector('.feel__tab-glider');
    var capsule = document.getElementById('feel-capsule');
    var capsuleLabel = document.getElementById('feel-capsule-label');
    var labels = {
      laxiva: 'Laxiva · overnight comfort',
      detoxa: 'Detoxa · gut reset cleanse'
    };

    function moveGlider(activeTab) {
      if (!glider || !activeTab) return;
      var parent = activeTab.parentElement.getBoundingClientRect();
      var rect = activeTab.getBoundingClientRect();
      glider.style.width = rect.width + 'px';
      glider.style.transform = 'translateX(' + (rect.left - parent.left) + 'px)';
    }

    function burstParticles(x, y) {
      var layer = document.createElement('div');
      layer.className = 'feel-burst';
      layer.style.left = x + 'px';
      layer.style.top = y + 'px';
      document.body.appendChild(layer);
      for (var i = 0; i < 14; i++) {
        var p = document.createElement('span');
        p.className = 'feel-burst__dot';
        var angle = (i / 14) * Math.PI * 2;
        var dist = 40 + Math.random() * 50;
        p.style.setProperty('--tx', Math.cos(angle) * dist + 'px');
        p.style.setProperty('--ty', Math.sin(angle) * dist + 'px');
        p.style.animationDelay = (Math.random() * 0.08) + 's';
        layer.appendChild(p);
      }
      setTimeout(function () {
        layer.remove();
      }, 700);
    }

    function staggerCards(panel) {
      if (!panel) return;
      var cards = panel.querySelectorAll('.feel-card');
      cards.forEach(function (card, i) {
        card.classList.remove('is-in');
        card.style.setProperty('--feel-i', i);
        requestAnimationFrame(function () {
          setTimeout(function () {
            card.classList.add('is-in');
          }, 40 + i * 70);
        });
      });
    }

    function switchTo(id, tabEl) {
      root.setAttribute('data-feel-theme', id);
      tabs.forEach(function (t) {
        var on = t === tabEl;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var match = panel.getAttribute('data-feel-panel') === id;
        panel.hidden = !match;
        panel.classList.toggle('is-active', match);
        if (match) staggerCards(panel);
      });
      moveGlider(tabEl);
      if (capsuleLabel) capsuleLabel.textContent = labels[id] || '';
      if (capsule) {
        capsule.classList.remove('is-flip');
        void capsule.offsetWidth;
        capsule.classList.add('is-flip');
      }
      root.classList.add('is-switching');
      setTimeout(function () {
        root.classList.remove('is-switching');
      }, 600);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        var id = tab.getAttribute('data-feel-tab');
        var rect = tab.getBoundingClientRect();
        burstParticles(rect.left + rect.width / 2, rect.top + rect.height / 2);
        switchTo(id, tab);
      });
    });

    // Magnetic tilt on cards
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!reduceMotion && finePointer) {
      root.querySelectorAll('.feel-tap').forEach(function (card) {
        var blob = card.querySelector('.feel-tap__blob');
        if (!blob) return;
        card.addEventListener('pointermove', function (e) {
          var r = blob.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          blob.style.transform =
            'scale(1.06) rotateX(' + (-py * 8) + 'deg) rotateY(' + (px * 10) + 'deg)';
        });
        card.addEventListener('pointerleave', function () {
          blob.style.transform = '';
        });
      });
    }

    // Parallax orbs with mouse
    if (!reduceMotion && finePointer) {
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        root.style.setProperty('--feel-mx', (x * 30).toFixed(1) + 'px');
        root.style.setProperty('--feel-my', (y * 20).toFixed(1) + 'px');
      });
    }

    var active = root.querySelector('.feel__tab.is-active');
    moveGlider(active);
    staggerCards(root.querySelector('.feel__panel.is-active'));
    window.addEventListener('resize', function () {
      moveGlider(root.querySelector('.feel__tab.is-active'));
    });
  }

  function renderCapsule(productKey) {
    var data = CAPSULE_DATA[productKey];
    var stage = document.getElementById('capsule-stage');
    var detail = document.getElementById('capsule-detail');
    var title = document.getElementById('capsule-product-name');
    var tagline = document.getElementById('capsule-tagline');
    var world = document.getElementById('capsule');
    if (!stage || !data) return;

    if (world) world.setAttribute('data-cap-product', productKey);
    if (title) title.textContent = data.name;
    if (tagline) tagline.textContent = data.tagline;

    var count = data.ingredients.length;
    var orbs = data.ingredients.map(function (ing, i) {
      var angle = (i / count) * Math.PI * 2 - Math.PI / 2;
      var radius = count > 8 ? (34 + (i % 2) * 10) : (38 + (i % 2) * 8);
      var x = 50 + Math.cos(angle) * radius;
      var y = 50 + Math.sin(angle) * radius;
      return (
        '<button type="button" class="cap-orb" data-ing-index="' + i + '"' +
          ' style="--ox:' + x + '%; --oy:' + y + '%; --bead-delay:' + (0.08 + i * 0.04) + 's; --bead-color:' + data.color + '">' +
          '<span class="cap-orb__core"></span>' +
          '<span class="cap-orb__ring"></span>' +
          '<span class="cap-orb__name">' + ing.name + '</span>' +
        '</button>'
      );
    }).join('');

    stage.innerHTML =
      '<div class="cap-scene" data-open="false" data-ing-count="' + count + '" style="--cap-a:' + data.color + '; --cap-b:' + data.colorDark + '">' +
        '<div class="cap-scene__tunnel" aria-hidden="true"></div>' +
        '<div class="cap-scene__dust" aria-hidden="true">' +
          '<span></span><span></span><span></span><span></span><span></span><span></span>' +
        '</div>' +
        '<button type="button" class="cap-shell" aria-expanded="false" aria-label="Open ' + data.name + ' capsule">' +
          '<span class="cap-shell__glow"></span>' +
          '<span class="cap-shell__half cap-shell__half--left"></span>' +
          '<span class="cap-shell__half cap-shell__half--right"></span>' +
          '<span class="cap-shell__seam"></span>' +
          '<span class="cap-shell__cta">' +
            '<strong>Tap to enter</strong>' +
            '<em>Explore all ' + count + ' ingredients</em>' +
          '</span>' +
        '</button>' +
        '<div class="cap-interior" hidden>' +
          '<p class="cap-interior__label">Inside ' + data.name + '</p>' +
          '<div class="cap-orbit">' + orbs + '</div>' +
          '<button type="button" class="cap-interior__close">Close capsule</button>' +
        '</div>' +
      '</div>';

    if (detail) {
      detail.innerHTML = '<p class="capsule-detail__prompt">Tap the capsule to step inside. Then select any glowing ingredient.</p>';
    }

    var scene = stage.querySelector('.cap-scene');
    var shell = stage.querySelector('.cap-shell');
    var interior = stage.querySelector('.cap-interior');
    var closeBtn = stage.querySelector('.cap-interior__close');

    function setOpen(open) {
      scene.setAttribute('data-open', open ? 'true' : 'false');
      shell.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (interior) {
        interior.hidden = !open;
        interior.setAttribute('aria-hidden', open ? 'false' : 'true');
      }
      if (world) world.classList.toggle('is-inside', open);
      // Keep closed-state CTA from blocking the close control
      var cta = shell.querySelector('.cap-shell__cta');
      if (cta) cta.hidden = !!open;
      if (detail && !open) {
        detail.innerHTML = '<p class="capsule-detail__prompt">Tap the capsule to step inside. Then select any glowing ingredient.</p>';
      }
    }

    shell.addEventListener('click', function () {
      setOpen(true);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setOpen(false);
      });
    }

    // Extra safety: clicking empty chamber chrome while open can close
    if (interior) {
      interior.addEventListener('click', function (e) {
        if (e.target === interior) setOpen(false);
      });
    }

    stage.querySelectorAll('.cap-orb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-ing-index'), 10);
        var ing = data.ingredients[idx];
        stage.querySelectorAll('.cap-orb').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        if (detail && ing) {
          detail.innerHTML =
            '<span class="cap-world__detail-badge">Ingredient ' + (idx + 1) + ' of ' + data.ingredients.length + '</span>' +
            '<strong class="capsule-detail__name">' + ing.name + '</strong>' +
            '<span class="capsule-detail__short">' + ing.short + '</span>' +
            '<p class="capsule-detail__text">' + ing.detail + '</p>';
        }
      });
    });
  }

  function initCapsuleExplorer() {
    var root = document.getElementById('capsule') || document.querySelector('.cap-world');
    if (!root) return;

    var switches = root.querySelectorAll('[data-capsule-product]');
    switches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-capsule-product');
        switches.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        root.classList.remove('is-inside');
        renderCapsule(key);
      });
    });

    renderCapsule('laxiva');
  }

  function initProductCapsules() {
    // Clicking the product photo opens Quick View.
    document.querySelectorAll('[data-open-capsule]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('.product-card');
        if (!card) return;
        var id = card.getAttribute('data-product-id');
        if (id && typeof window.WellProofOpenQuickView === 'function') {
          window.WellProofOpenQuickView(id);
        }
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        btn.click();
      });
    });
  }

  function initHeroCinematic() {
    var root = document.querySelector('[data-hero-cine]');
    if (!root) return;

    var layers = root.querySelectorAll('[data-parallax]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!reduce && fine) {
      var targetX = 0;
      var targetY = 0;
      var curX = 0;
      var curY = 0;
      var ticking = false;

      function paint() {
        curX += (targetX - curX) * 0.08;
        curY += (targetY - curY) * 0.08;
        layers.forEach(function (el) {
          var strength = parseFloat(el.getAttribute('data-parallax')) || 0.04;
          el.style.transform =
            'translate3d(' + (curX * strength * 100) + 'px,' + (curY * strength * 80) + 'px,0)';
        });
        if (Math.abs(targetX - curX) > 0.001 || Math.abs(targetY - curY) > 0.001) {
          requestAnimationFrame(paint);
        } else {
          ticking = false;
        }
      }

      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        targetX = (e.clientX - r.left) / r.width - 0.5;
        targetY = (e.clientY - r.top) / r.height - 0.5;
        root.classList.add('is-hot');
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(paint);
        }
      });

      root.addEventListener('pointerleave', function () {
        targetX = 0;
        targetY = 0;
        root.classList.remove('is-hot');
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(paint);
        }
      });
    }

    // Title hover brightens media
    root.querySelectorAll('[data-word]').forEach(function (word) {
      word.addEventListener('mouseenter', function () {
        root.classList.add('is-hot');
      });
    });

    root.classList.add('is-ready');
  }

  function initHeroSwitch() {
    var root = document.querySelector('[data-hero-switch]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hero-tab]'));
    var switchTabs = Array.prototype.slice.call(root.querySelectorAll('.hero-mx__tab, .split-hero__tab, .split-hero__pick'));
    if (!tabs.length) return;

    function select(key) {
      if (!key || root.getAttribute('data-hero-product') === key) return;
      root.setAttribute('data-hero-product', key);

      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-hero-tab') === key;
        tab.classList.toggle('is-active', on);
        if (tab.getAttribute('role') === 'tab') {
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        }
      });

      var views = Array.prototype.slice.call(root.querySelectorAll('[data-hero-view]'));
      views.forEach(function (view) {
        var on = view.getAttribute('data-hero-view') === key;
        view.classList.toggle('is-in', on);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab.getAttribute('data-hero-tab'));
      });
    });

    // arrow keys walk the tablist
    switchTabs.forEach(function (tab, i) {
      tab.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        var next = switchTabs[(i + step + switchTabs.length) % switchTabs.length];
        select(next.getAttribute('data-hero-tab'));
        next.focus();
      });
    });
  }

  function initScienceLab() {
    var root = document.querySelector('[data-science-lab]');
    if (!root) return;

    var items = root.querySelectorAll('[data-science-index]');
    var showcase = document.getElementById('science-showcase');
    var coreLabel = document.getElementById('science-core-label');
    var stage = document.getElementById('science-stage');
    var orbit = document.getElementById('science-orbit');
    if (!items.length || !showcase || !stage) return;

    var data = [
      { name: 'Haritaki + Senna', tag: 'Motility & regularity', formula: 'Laxiva', color: '#00c9a7' },
      { name: 'Fennel + Ajwain + Mint', tag: 'Less gas & bloating', formula: 'Laxiva', color: '#1fa88a' },
      { name: 'Psyllium + Probiotic', tag: 'Cleanse & rebalance', formula: 'Detoxa', color: '#1f6b4a' }
    ];

    var angle = -90;
    var paused = false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var spokes = orbit ? orbit.querySelectorAll('.sci-viz__spoke') : [];

    function placeBeads() {
      var size = stage.clientWidth || 320;
      var radius = size * 0.38;
      spokes.forEach(function (spoke, i) {
        var a = (angle + i * 120) * Math.PI / 180;
        var x = Math.cos(a) * radius;
        var y = Math.sin(a) * radius;
        spoke.style.transform = 'translate(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px)';
      });
    }

    function tick() {
      if (!paused && !reduce) {
        angle += 0.4;
        if (angle > 270) angle -= 360;
        placeBeads();
      }
      requestAnimationFrame(tick);
    }

    function render(index) {
      var d = data[index];
      if (!d) return;

      items.forEach(function (btn) {
        var on = parseInt(btn.getAttribute('data-science-index'), 10) === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (coreLabel) coreLabel.textContent = d.formula;

      showcase.innerHTML =
        '<div class="sci-viz__flash" style="--accent:' + d.color + '">' +
          '<strong>' + d.name + '</strong>' +
          '<span>' + d.tag + '</span>' +
        '</div>';
      showcase.classList.remove('is-on');
      void showcase.offsetWidth;
      showcase.classList.add('is-on');
    }

    items.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        render(parseInt(btn.getAttribute('data-science-index'), 10));
        paused = true;
        stage.classList.add('is-paused');
        window.clearTimeout(stage._resumeTimer);
        stage._resumeTimer = window.setTimeout(function () {
          paused = false;
          stage.classList.remove('is-paused');
        }, 3200);
      });
    });

    stage.addEventListener('mouseenter', function () {
      paused = true;
      stage.classList.add('is-paused');
    });
    stage.addEventListener('mouseleave', function () {
      paused = false;
      stage.classList.remove('is-paused');
    });

    window.addEventListener('resize', placeBeads);
    placeBeads();
    render(0);
    requestAnimationFrame(tick);
  }

  function initFounderJourney() {
    var root = document.querySelector('[data-founder-journey]');
    if (!root) return;

    var steps = root.querySelectorAll('[data-founder-step]');
    var panel = document.getElementById('founder-story-panel');
    var progress = document.getElementById('founder-progress');
    if (!steps.length || !panel) return;

    var stories = [
      { title: 'Digestive discomfort', text: 'Years of bloating. No lasting relief.', mood: 'problem' },
      { title: 'Ayurveda meets research', text: 'Ancient herbs. Modern standards.', mood: 'discovery' },
      { title: 'Laxiva & Detoxa', text: 'Two formulas. Transparent ingredients.', mood: 'launch' },
      { title: 'Well & Proof', text: 'Natural relief you can trust.', mood: 'today' }
    ];

    function activate(index) {
      var story = stories[index];
      if (!story) return;

      steps.forEach(function (step) {
        var on = parseInt(step.getAttribute('data-founder-step'), 10) === index;
        step.classList.toggle('is-active', on);
        step.classList.toggle('is-done', parseInt(step.getAttribute('data-founder-step'), 10) < index);
        step.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (progress) {
        progress.style.width = (index / (stories.length - 1) * 100) + '%';
      }

      panel.innerHTML =
        '<p class="path__card-kicker">Step ' + (index + 1) + ' / ' + stories.length + '</p>' +
        '<h3 class="path__card-title">' + story.title + '</h3>' +
        '<p class="path__card-text">' + story.text + '</p>';
      panel.setAttribute('data-mood', story.mood);
      panel.classList.remove('is-on');
      void panel.offsetWidth;
      panel.classList.add('is-on');
    }

    steps.forEach(function (step) {
      step.addEventListener('click', function () {
        activate(parseInt(step.getAttribute('data-founder-step'), 10));
      });
    });

    activate(0);
  }

  function initPillars() {
    var root = document.getElementById('pillars');
    if (!root) return;

    if (!(root.hasAttribute('data-pillars-slides') || root.classList.contains('pillars--numi'))) {
      return;
    }

    var bgs = root.querySelectorAll('.pillars-numi__bg');
    var panels = root.querySelectorAll('.pillars-numi__panel');
    var cols = root.querySelectorAll('[data-pillar-col]');
    var dots = root.querySelectorAll('[data-pillars-dot]');
    var prevBtns = root.querySelectorAll('[data-pillars-prev]');
    var nextBtns = root.querySelectorAll('[data-pillars-next]');
    var viewport = root.querySelector('.pillars-numi') || root;
    var total = Math.max(bgs.length, panels.length, 1);
    if (!bgs.length && !panels.length) return;

    // Fixed pairing:
    // 0 Natural, 1 Safety, 2 Efficacy, 3 Transparency, 4 No Overloading
    var index = 0;
    var timer = null;
    var locked = false;
    var startX = 0;
    var deltaX = 0;
    var tracking = false;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function go(to, options) {
      var opts = options || {};
      index = (to + total) % total;

      bgs.forEach(function (bg, i) {
        var on = i === index;
        bg.classList.toggle('is-active', on);
        if (on && bg.getAttribute('loading') === 'lazy') {
          bg.loading = 'eager';
        }
      });

      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);
        panel.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      cols.forEach(function (col, i) {
        col.classList.toggle('is-active', i === index);
      });

      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      root.setAttribute('data-active-pillar', String(index));

      if (opts.lock) {
        locked = true;
        stopAuto();
      } else if (opts.unlock) {
        locked = false;
      }
    }

    function next() { go(index + 1); }
    function prev() { go(index - 1); }

    function startAuto() {
      stopAuto();
      if (locked) return;
      timer = window.setInterval(next, 6500);
    }

    function stopAuto() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function selectPillar(i, lock) {
      go(i, { lock: !!lock });
      if (!lock) startAuto();
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        locked = false;
        prev();
        startAuto();
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        locked = false;
        next();
        startAuto();
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        selectPillar(parseInt(dot.getAttribute('data-pillars-dot'), 10) || 0, true);
      });
    });

    cols.forEach(function (col) {
      var i = parseInt(col.getAttribute('data-pillar-col'), 10) || 0;
      col.setAttribute('tabindex', '0');
      col.setAttribute('role', 'button');
      col.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');

      if (finePointer) {
        col.addEventListener('mouseenter', function () {
          selectPillar(i, true);
          cols.forEach(function (c, ci) {
            c.setAttribute('aria-pressed', ci === i ? 'true' : 'false');
          });
        });
      }

      col.addEventListener('click', function (e) {
        // Allow Learn more links to navigate normally
        if (e.target.closest('a')) return;
        e.preventDefault();
        selectPillar(i, true);
        cols.forEach(function (c, ci) {
          c.setAttribute('aria-pressed', ci === i ? 'true' : 'false');
        });
      });

      col.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPillar(i, true);
          cols.forEach(function (c, ci) {
            c.setAttribute('aria-pressed', ci === i ? 'true' : 'false');
          });
        }
      });
    });

    // Mobile panels: tap locks that pillar's image
    panels.forEach(function (panel) {
      panel.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var i = parseInt(panel.getAttribute('data-slide'), 10) || 0;
        selectPillar(i, true);
      });
    });

    function onStart(x) {
      tracking = true;
      startX = x;
      deltaX = 0;
      stopAuto();
    }

    function onMove(x) {
      if (!tracking) return;
      deltaX = x - startX;
    }

    function onEnd() {
      if (!tracking) return;
      tracking = false;
      if (Math.abs(deltaX) > 40) {
        locked = false;
        if (deltaX < 0) next();
        else prev();
      }
      startAuto();
    }

    viewport.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches[0]) onStart(e.touches[0].clientX);
    }, { passive: true });
    viewport.addEventListener('touchmove', function (e) {
      if (e.touches && e.touches[0]) onMove(e.touches[0].clientX);
    }, { passive: true });
    viewport.addEventListener('touchend', onEnd);
    viewport.addEventListener('touchcancel', onEnd);

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', function () {
      locked = false;
      startAuto();
    });

    go(0);
    startAuto();
  }

  function initStandard() {
    var root = document.querySelector('[data-standard]');
    if (!root) return;

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-standard-step]'));
    var card = root.querySelector('.standard__card');
    if (!steps.length || !card) return;

    var fill = root.querySelector('[data-standard-fill]');
    var numEl = root.querySelector('[data-standard-num]');
    var answerEl = root.querySelector('[data-standard-answer]');
    var bodyEl = root.querySelector('[data-standard-body]');
    var pillarEl = root.querySelector('[data-standard-pillar]');
    var ring = root.querySelector('[data-standard-ring]');
    var ringNum = root.querySelector('[data-standard-ring-num]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-standard-item]'));
    var jump = root.querySelector('[data-standard-jump]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var total = steps.length;
    var index = 0;
    var timer = null;
    var swapTimer = null;
    var paused = false;
    var visible = false;

    function paint(to) {
      index = (to + total) % total;
      var step = steps[index];

      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
        s.classList.toggle('is-done', i < index);
        s.setAttribute('aria-selected', i === index ? 'true' : 'false');
        s.setAttribute('tabindex', i === index ? '0' : '-1');
      });

      items.forEach(function (li, i) {
        li.classList.toggle('is-current', i === index);
        li.classList.toggle('is-done', i < index);
      });

      // rail tip lands on the active circle; ring counts checkpoints passed
      var reach = total > 1 ? index / (total - 1) : 1;
      if (fill) fill.style.setProperty('--std-fill', (reach * 100).toFixed(2) + '%');
      if (ring) ring.style.setProperty('--std-ring', ((index + 1) / total).toFixed(3));
      if (ringNum) ringNum.textContent = String(index + 1);
      if (numEl) numEl.textContent = String(index + 1);
      if (answerEl) answerEl.textContent = step.getAttribute('data-answer') || '';
      if (bodyEl) bodyEl.textContent = step.getAttribute('data-body') || '';
      if (pillarEl) pillarEl.textContent = step.getAttribute('data-pillar') || '';
      if (jump) jump.setAttribute('data-standard-jump', String(index));
      card.setAttribute('aria-labelledby', step.id || 'standard-tab-' + index);
    }

    function show(to) {
      if ((to + total) % total === index) return;
      if (reduce) {
        paint(to);
        return;
      }
      card.classList.add('is-swapping');
      window.clearTimeout(swapTimer);
      swapTimer = window.setTimeout(function () {
        paint(to);
        card.classList.remove('is-swapping');
      }, 240);
    }

    function stopAuto() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function startAuto() {
      if (root.hasAttribute('data-quest-scene')) return;
      if (timer || reduce || !visible) return;
      timer = window.setInterval(function () {
        if (paused) return;
        show(index + 1);
      }, 3000);
    }

    var questScroll = root.hasAttribute('data-quest-scene');

    if (questScroll) {
      root.addEventListener('quest:set', function (e) {
        paint(e.detail);
      });
    }

    steps.forEach(function (step, i) {
      if (questScroll) return;
      step.addEventListener('click', function () {
        show(i);
        stopAuto();
        startAuto();
      });

      step.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % total;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + total) % total;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = total - 1;
        if (next === null) return;
        e.preventDefault();
        show(next);
        stopAuto();
        startAuto();
        steps[next].focus();
      });
    });

    // The checkpoint link opens the matching slide of the pillars carousel below.
    if (jump) {
      jump.addEventListener('click', function () {
        var i = parseInt(jump.getAttribute('data-standard-jump'), 10) || 0;
        var dot = document.querySelector('[data-pillars-dot="' + i + '"]');
        if (dot) window.setTimeout(function () { dot.click(); }, 520);
      });
    }

    root.addEventListener('pointerenter', function () { paused = true; });
    root.addEventListener('pointerleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) startAuto();
          else stopAuto();
        });
      }, { threshold: 0.35 }).observe(root);
    } else {
      visible = true;
      startAuto();
    }

    paint(0);
  }

  function init() {
    initFeelOrbits();
    initFeelTabs();
    initCapsuleExplorer();
    initProductCapsules();
    initHeroCinematic();
    initHeroSwitch();
    initStandard();
    initPillars();
    initScienceLab();
    initFounderJourney();
    initDayFeel();
    initFaqHelp();
    initFaqMore();
    initFormulaGlance();
  }

  function initFormulaGlance() {
    var root = document.querySelector('[data-formula-lab]');
    if (!root) {
      document.querySelectorAll('[data-open-formula]').forEach(function (link) {
        link.addEventListener('click', function () {
          var key = link.getAttribute('data-open-formula');
          var capsule = document.getElementById('capsule');
          if (!capsule || !key) return;
          var btn = capsule.querySelector('[data-capsule-product="' + key + '"]');
          if (btn) btn.click();
        });
      });
      return;
    }

    var tabs = root.querySelectorAll('[data-formula-tab]');
    var stage = root.querySelector('.formula-lab__stage');
    var countEl = root.querySelector('[data-formula-count]');
    var blurbEl = root.querySelector('[data-formula-blurb]');
    var ctaEl = root.querySelector('[data-formula-cta]');
    var glider = root.querySelector('.formula-lab__glider');
    var focusBox = root.querySelector('[data-formula-focus]');
    var focusPhoto = root.querySelector('[data-formula-focus-photo]');
    var focusRole = root.querySelector('[data-formula-focus-role]');
    var focusName = root.querySelector('[data-formula-focus-name]');
    var focusDetail = root.querySelector('[data-formula-focus-detail]');
    var copy = {
      laxiva: {
        count: '12',
        blurb: 'We believe the best formulations are built on purpose, not excess. That’s why our products are crafted without unnecessary additives, artificial preservatives, or harsh chemicals. Every ingredient is thoughtfully selected to deliver quality you can trust and transparency you can see.',
        cta: 'Shop Laxiva'
      },
      detoxa: {
        count: '7',
        blurb: 'Our commitment is simple: use only what adds value. Every ingredient is chosen with intention, while unnecessary additives, artificial preservatives, and harsh chemicals are deliberately left out. Because genuine wellness starts with honest formulation.',
        cta: 'Shop Detoxa'
      }
    };
    var activeChip = null;

    function moveGlider(tab) {
      if (!glider || !tab) return;
      var parent = tab.parentElement;
      if (!parent) return;
      var pRect = parent.getBoundingClientRect();
      var tRect = tab.getBoundingClientRect();
      glider.style.width = tRect.width + 'px';
      glider.style.transform = 'translateX(' + (tRect.left - pRect.left) + 'px)';
    }

    function closeCapsule() {
      root.classList.remove('is-open');
      activeChip = null;
      if (focusBox) focusBox.hidden = true;
      root.querySelectorAll('[data-formula-ings] button').forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.style.transform = '';
      });
    }

    function openCapsule(btn) {
      var role = btn.getAttribute('data-ing-role') || '';
      var detail = btn.getAttribute('data-ing-detail') || '';
      var nameEl = btn.querySelector('.ing-orb__name');
      var name = nameEl ? nameEl.textContent.trim() : btn.textContent.trim();

      root.classList.add('is-open');
      activeChip = btn;

      root.querySelectorAll('[data-formula-ings] button').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        if (b !== btn) b.style.transform = '';
      });

      if (focusBox) {
        var srcImg = btn.querySelector('.ing-chip__photo img');
        if (focusPhoto) {
          if (srcImg) {
            focusPhoto.src = srcImg.currentSrc || srcImg.src;
            focusPhoto.alt = name;
            focusPhoto.hidden = false;
          } else {
            focusPhoto.removeAttribute('src');
            focusPhoto.hidden = true;
          }
        }
        if (focusRole) focusRole.textContent = role || 'Ingredient';
        if (focusName) focusName.textContent = name;
        if (focusDetail) focusDetail.textContent = detail || role;
        focusBox.hidden = false;
        focusBox.classList.remove('is-pop');
        void focusBox.offsetWidth;
        focusBox.classList.add('is-pop');
      }
    }

    function setFormula(key) {
      var data = copy[key];
      if (!data) return;

      root.setAttribute('data-active', key);
      if (stage) stage.setAttribute('data-formula-panel', key);
      closeCapsule();

      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-formula-tab') === key;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) moveGlider(tab);
      });

      root.querySelectorAll('[data-formula-ings]').forEach(function (list) {
        var show = list.getAttribute('data-formula-ings') === key;
        list.hidden = !show;
        if (show) {
          list.classList.remove('is-enter');
          void list.offsetWidth;
          list.classList.add('is-enter');
        } else {
          list.classList.remove('is-enter');
        }
      });

      if (countEl) {
        countEl.classList.remove('is-pop');
        void countEl.offsetWidth;
        countEl.textContent = data.count;
        countEl.classList.add('is-pop');
      }
      if (blurbEl) blurbEl.textContent = data.blurb;
      if (ctaEl) ctaEl.textContent = data.cta;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setFormula(tab.getAttribute('data-formula-tab'));
      });
    });

    root.querySelectorAll('[data-formula-ings] button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (activeChip === btn) {
          closeCapsule();
          return;
        }
        openCapsule(btn);
      });
    });

    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (stage && fine && !reduce) {
      var max = 7;
      stage.addEventListener('pointermove', function (e) {
        var rect = stage.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        var rotY = (x - 0.5) * max * 2;
        var rotX = (0.5 - y) * max * 2;
        stage.style.transform =
          'rotateX(' + rotX.toFixed(2) + 'deg) rotateY(' + rotY.toFixed(2) + 'deg)';
      });
      stage.addEventListener('pointerleave', function () {
        stage.style.transform = '';
      });
    }

    if (fine && !reduce) {
      root.querySelectorAll('[data-formula-ings] button').forEach(function (btn) {
        btn.addEventListener('pointermove', function (e) {
          if (btn.classList.contains('is-active')) return;
          var rect = btn.getBoundingClientRect();
          var x = (e.clientX - rect.left) / rect.width - 0.5;
          var y = (e.clientY - rect.top) / rect.height - 0.5;
          btn.style.transform =
            'translateY(-6px) rotateX(' + (6 - y * 10).toFixed(1) + 'deg) rotateY(' + (x * 12).toFixed(1) + 'deg) scale(1.04)';
        });
        btn.addEventListener('pointerleave', function () {
          if (!btn.classList.contains('is-active')) btn.style.transform = '';
        });
      });
    }

    setFormula('laxiva');
    window.addEventListener('resize', function () {
      var active = root.querySelector('.formula-lab__tab.is-active');
      moveGlider(active);
      if (window.matchMedia('(max-width: 900px)').matches && stage) {
        stage.style.transform = '';
      }
    });
  }

  function initDayFeel() {
    var root = document.querySelector('[data-day-feel]');
    if (!root) return;

    var cards = root.querySelectorAll('[data-day]');
    var spotlight = document.getElementById('day-spotlight');
    var textEl = spotlight ? spotlight.querySelector('.day__spotlight-text') : null;
    if (!cards.length) return;

    var lines = [
      'Start the day without the heaviness.',
      'Enjoy meals without the bloat.',
      'Move through the evening feeling settled.',
      'Rest easy — wake up ready again.'
    ];

    function activate(index) {
      cards.forEach(function (card) {
        var on = parseInt(card.getAttribute('data-day'), 10) === index;
        card.classList.toggle('is-active', on);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (textEl) {
        textEl.textContent = lines[index] || lines[0];
      }
      if (spotlight) {
        spotlight.setAttribute('data-mood', String(index));
        spotlight.classList.remove('is-on');
        void spotlight.offsetWidth;
        spotlight.classList.add('is-on');
      }
      root.setAttribute('data-day-active', String(index));
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        activate(parseInt(card.getAttribute('data-day'), 10));
      });
      card.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          activate(parseInt(card.getAttribute('data-day'), 10));
        }
      });
    });

    activate(0);
  }

  function initFaqHelp() {
    var root = document.querySelector('[data-faq-help]');
    if (!root) return;

    var chips = root.querySelectorAll('[data-faq-filter]');
    var items = root.querySelectorAll('.ask-item[data-faq-cat]');
    if (!chips.length || !items.length) return;

    function filter(cat) {
      chips.forEach(function (chip) {
        var on = chip.getAttribute('data-faq-filter') === cat;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      items.forEach(function (item) {
        var show = cat === 'all' || item.getAttribute('data-faq-cat') === cat;
        item.hidden = !show;
        if (!show) {
          var trigger = item.querySelector('.accordion__trigger');
          var panel = item.querySelector('.accordion__panel');
          item.classList.remove('is-open', 'active');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (panel) panel.hidden = true;
        }
      });

      var first = null;
      items.forEach(function (item) {
        if (!first && !item.hidden) first = item;
      });
      if (first) {
        var t = first.querySelector('.accordion__trigger');
        var p = first.querySelector('.accordion__panel');
        if (t && p) {
          t.setAttribute('aria-expanded', 'true');
          p.hidden = false;
          first.classList.add('is-open', 'active');
        }
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        filter(chip.getAttribute('data-faq-filter'));
      });
    });
  }

  function initFaqMore() {
    var root = document.querySelector('.ask--faq');
    var btn = document.querySelector('[data-faq-more]');
    if (!root || !btn) return;
    var extra = root.querySelectorAll('.ask-item:nth-child(n+5)');
    if (!extra.length) {
      btn.hidden = true;
      return;
    }

    btn.addEventListener('click', function () {
      var open = root.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show fewer FAQs' : 'See all FAQs';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
